import {AfterViewInit, Component, ElementRef, Input, Renderer2} from '@angular/core';
import {ButtonControl} from '../../../models/uiArtefakt';
import {ExternalResourceDialogComponent} from '../../popupDialog/external-resource-dialog/external-resource-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'lv-info-button',
    templateUrl: './info-button.component.html',
    styleUrls: ['./info-button.component.scss'],
    standalone: false
})
export class InfoButtonComponent implements AfterViewInit {

  private _uiArtefakt: ButtonControl;

  constructor(private _dialog: MatDialog,
              private _renderer: Renderer2, private _element: ElementRef) { }

  get uiArtefakt(): ButtonControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: ButtonControl) {
    this._uiArtefakt = uiArtefakt;
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  openModalDialog() {
    this._dialog.open(ExternalResourceDialogComponent, {
      panelClass: 'lv-external-resource-dialog',
      data: {
        externalResourceUrl: this.uiArtefakt.HtmlSeiteExtern
      }
    });
  }
}
